<template src="./index.html"></template>

<script>
import FlagButton from "@/components/FlagButton.vue";
import BeFooter from "@/components/BeFooter.vue";
import Recaptcha from "@/components/Recaptcha.vue";
import { S3Service } from "@/services/s3.service.js";
import axios from "axios";
import { lookup } from 'mime-types'
export default {
  name: "FormPage",
  components: { FlagButton, BeFooter, Recaptcha },

  props: {
    msg: String,
    client: String,
    form: String,
  },

  data() {
    return {
      localLanguage: "pt-BR",
      holderOccupations: [],
      saving: false,
      showForm: true,
      showError: false,
      options: null,
      error_load: false,
      tab: "new",
      errors: {},
      types: [],
      applicantOptions: [{ value: 'holder', text: this.$t('form.applicantOptions.holder')}, { value: 'legal_representative', text: this.$t('form.applicantOptions.legalRepresentative')}],
      files: [],
      applicantFiles: [],
      validFiles: { defaultFiles: [], applicantFiles: []},
      invalidFiles: { defaultFiles: [], applicantFiles: []},
      errorFileMessage: "",
      maxFileSize: 10 * 1024 * 1024,
      data: {
        name: "",
      },
      showStatus: false,
      showErrorQuery: false,
      protocol: "",
      errorsQuery: {},
      statusText: "",
      site_url: process.env.VUE_APP_SITE_URL,
      cpf_required: false,
      privacyPolicyUrl: null,
      locations: [],
      birth_date: null,
      recaptchaToken: null,
      otherOccupationId: null,
    };
  },

  mounted() {
    if (!this.client) {
      this.client = this.$route.query.client;
    }
    if (!this.form) {
      this.form = this.$route.query.form;
    }

    const { query } = this.$route;
    let { language = "pt-BR" } = query;
    if ("lang" in query) {
      language = query.lang;
    }
    if (language == "es") {
      language = "esp";
    }
    switch (language.trim()) {
      case "es":
        language = "esp";
        break;
      case "pt":
        language = "pt-BR";
        break;
    }
    this.$i18n.locale = language;

    this.createForm({ language });
  },
  computed: {
    computedChipColors() {
      const colors = {
        bgc: "#17a2b8",
        fc: "#ffffff",
      };

      const bg_hex =
        typeof this.options.background_color === "string"
          ? this.options.background_color
          : this.options.background_color?.hex;
      const fc_hex =
        typeof this.options.font_color === "string"
          ? this.options.font_color
          : this.options.font_color?.hex;

      if (bg_hex) {
        if (this.getContrastRatio("#ffffff", bg_hex) >= 3) {
          colors.bgc = bg_hex;
          colors.fc = fc_hex ? fc_hex : "#ffffff";
        } else {
          if (fc_hex) {
            colors.bgc = fc_hex;
            colors.fc = bg_hex;
          }
        }
      } else if (fc_hex) {
        if (this.getContrastRatio("#ffffff", fc_hex) >= 3) {
          colors.bgc = fc_hex;
        }
      }

      return colors;
    }
  },

  methods: {
    triggerInputFile(event){
      if(event.target?.className === 'file-input-container') {
        this.$refs.fileInput.click();
      }

      if(event.target?.className === 'applicant-file-input-container') {
        this.$refs.applicantFileInput.click();
      }
    },
    handleFiles(event, field = 'defaultFiles') {
      this.deleteAllFiles(field);
      const selectedFiles = Array.from(event.target.files);
      const validFiles = [];
      const invalidFiles = [];

      selectedFiles.forEach((file) => {
        if (file.size <= this.maxFileSize) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file);
        }
      });

      if (invalidFiles.length > 0) {
        this.errorFileMessage = `Os seguintes arquivos excedem o limite de 10 MB: ${invalidFiles.map(file => file.name).join(
          ", "
        )}`;
      }

      if (field == "applicantFiles") {
        this.applicantFiles = selectedFiles
      } else {
        this.files = selectedFiles;
      }

      this.validFiles[field] = validFiles;
      this.invalidFiles[field] = invalidFiles;
      event.target.value = '';
    },
    deleteFile(index, type, field) {
      if (type === "valid") {
        this.validFiles[field].splice(index, 1);
      } else if (type === "invalid") {
        this.invalidFiles[field].splice(index, 1);
        if (this.invalidFiles[field].length === 0) {
          this.errorFileMessage = "";
        } else {
          this.errorFileMessage = `Os seguintes arquivos excedem o limite de 10 MB: ${this.invalidFiles[field].join(
            ", "
          )}`;
        }
      }
    },
    deleteAllFiles(field) {
      if (!field) {
        this.validFiles = { defaultFiles: [], applicantFiles: []};
        this.invalidFiles = { defaultFiles: [], applicantFiles: []};
        this.errorFileMessage = "";
        return
      }

      this.validFiles[field] = []
      this.invalidFiles[field] = []
      this.errorFileMessage = "";
    },
    getLang2Letters() {
      return this.$i18n.locale.substring(0, 2);
    },
    handleFlagChange(language) {
      this.localLanguage = language;
      this.createForm({ language });
      this.$emit("changeLanguage", language);
    },
    handleHolderOccupationChange(value) {
      if (value !== "other") {
        this.data.holder_occupation_description = "";
      }
    },
    clearForm() {
      this.data = {};
      this.birth_date = null;
      this.showForm = true;
      this.showError = false;
      this.errors = {};
      this.recaptchaToken = null;
      this.deleteAllFiles();
    },
    async createForm(params = { language: "pt-BR" }) {
      await axios
        .get(
          process.env.VUE_APP_CLOUD_FRONT_URL +
            `${this.client}/${this.form}${params.language}.json`
        )
        .then((res) => {
          if (!res.data.options) throw Error();
          this.locations = res.data.locations;
          this.holderOccupations = res.data.holder_occupations;
          const occupations = res.data.holder_occupations;
          const otherOccupations = occupations.filter((item) => {
            const isOtherOccupation =
              item.text === "Outro (opção para descrever)" ||
              item.text === "Otro (Opción para describir)" ||
              item.text === "Other (Option to describe)" ||
              item.text === "Outro (opção para descrever)" ||
              item.text === "Sonstiges (Option zur Beschreibung)";
            return isOtherOccupation;
          });
          this.otherOccupationId = otherOccupations.at(0)?.value;
          this.holderOccupations = res.data.holder_occupations;
          this.holderOccupations = this.holderOccupations.filter(
            (item) => item.value !== this.otherOccupationId
          );
          this.holderOccupations.push(otherOccupations.at(0));
          this.options = { ...res.data.options };
          this.types = res.data.types;
          this.cpf_required = res.data.cpf_required;
          this.privacyPolicyUrl = this.options.privacy_policy_url;
          this.$emit("getform", res.data);
        })
        .catch((err) => {
          axios
            .get(process.env.VUE_APP_API_URL + "lgpd-titular/form", {
              params: {
                client: this.client,
                form: this.form,
                ...params,
              },
            })
            .then((res) => {
              this.locations = res.data.locations;
              const occupations = res.data.holder_occupations;
              const otherOccupations = occupations.filter((item) => {
                const isOtherOccupation =
                  item.text === "Outro (opção para descrever)" ||
                  item.text === "Otro (Opción para describir)" ||
                  item.text === "Other (Option to describe)" ||
                  item.text === "Outro (opção para descrever)" ||
                  item.text === "Sonstiges (Option zur Beschreibung)";
                return isOtherOccupation;
              });
              this.otherOccupationId = otherOccupations.at(0)?.value;
              this.holderOccupations = res.data.holder_occupations;
              this.holderOccupations = this.holderOccupations.filter(
                (item) => item.value !== this.otherOccupationId
              );
              this.holderOccupations.push(otherOccupations.at(0));
              this.options = { ...res.data.options };
              this.types = res.data.types;
              this.cpf_required = res.data.cpf_required;
              this.privacyPolicyUrl = this.options.privacy_policy_url;
              this.$emit("getform", res.data);
            })
            .catch((err) => {
              this.error_load = true;
              this.$emit("getform", null);
            });
        });
    },

    queryForm() {
      if (!this.protocol || this.protocol.trim().length == 0) {
        return;
      }
      this.saving = true;
      this.showErrorQuery = false;
      this.errorsQuery = {};
      this.showStatus = false;
      this.statusText = "";

      let url = process.env.VUE_APP_API_URL;
      url += "lgpd-titular/status";
      url += `/${this.client}/${this.protocol}`;

      axios
        .get(url)
        .then((res) => {
          this.showStatus = true;
          this.statusText = res.data.status;
        })
        .catch(() => {
          this.showStatus = true;
          this.statusText = "Protocolo não encotrado";
        })
        .finally(() => {
          this.saving = false;
        });
    },

    async submitFiles(files) {
      const response = await axios.post(
        process.env.VUE_APP_API_MS_URL + "lgpd-titular/submit-files",
        {
          files: files.map((file) => {
            let mime = lookup(file.name)
            if (!mime) {
              mime = file.name.split('.').pop();
            }
          return {
            file: file.name,
            acl: "private",
            mime: mime,
            size: file.size,
          }}),
        },
        {
          params: {
            client: this.client,
            form: this.form,
          },
        }
      );
      return response;
    },

    async postForm() {
      this.saving = true;
      this.errorFileMessage = ''
      this.showError = false;
      this.errors = {};
      this.data.birth_date = null;
      if (
        this.localLanguage == "en" &&
        this.birth_date &&
        this.birth_date.trim().length > 0
      ) {
        this.data.birth_date = this.birth_date.trim().replaceAll("/", "-");
      } else {
        if (this.birth_date && this.birth_date.trim().length > 0) {
          this.data.birth_date = "";
          const splitDate = this.birth_date.split("/");
          if (splitDate[2]) {
            this.data.birth_date += splitDate[2] + "-";
          }
          if (splitDate[1]) {
            this.data.birth_date += splitDate[1] + "-";
          }
          if (splitDate[0]) {
            this.data.birth_date += splitDate[0];
          }
        }
      }

      const hasApplicantLegalRepresentative = this.options.show_applicant_field 
        && this.data.applicant == 'legal_representative'
      if (hasApplicantLegalRepresentative) {
        if (!!this.validFiles['applicantFiles']?.length) {
          const { data } = await this.submitFiles(this.validFiles['applicantFiles']);
          for (const [index, item] of data?.entries()) {
            const s3Service = new S3Service(decodeURIComponent(item.data?.url));
            await s3Service.upload(this.applicantFiles[index], item.data?.inputs);
            if (!this.data.applicantFiles) {
              this.data.applicantFiles = [];
            }
            this.data.applicantFiles.push(item.file_id);
          }
        } else {
          this.errorFileMessage = this.$t('errors.evidenceMissingError')
          this.saving = false
          return
        }
      }

      if (this.options.show_file_field && !!this.validFiles['defaultFiles']?.length) {
        const { data } = await this.submitFiles(this.validFiles['defaultFiles']);
        for (const [index, item] of data?.entries()) {
          const s3Service = new S3Service(decodeURIComponent(item.data?.url));
          await s3Service.upload(this.files[index], item.data?.inputs);
          if (!this.data.files) {
            this.data.files = [];
          }
          this.data.files.push(item.file_id);
        }
      }

      axios
        .post(process.env.VUE_APP_API_MS_URL + "lgpd-titular", {
          client: this.client,
          form: this.form,
          language: this.localLanguage,
          ...this.data,
          recaptchaToken: this.recaptchaToken,
        })
        .then(() => {
          this.showForm = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 422) {
            for (let key in error.response.data.errors) {
              this.$set(this.errors, key, true);
            }
          }
          this.showError = true;
          this.recaptchaToken = null;
          this.$refs.recaptchaComponent.reset();
          setTimeout(() => {
            var body = document.body,
              html = document.documentElement;

            var height = Math.max(
              body.scrollHeight,
              body.offsetHeight,
              html.clientHeight,
              html.scrollHeight,
              html.offsetHeight
            );

            window.top.postMessage(
              JSON.stringify({
                type: "height",
                height: height - 20,
              }),
              "*"
            );
          }, 100);
        })
        .finally(() => {
          this.saving = false;
        });
    },

    getLogo() {
      return process.env.VUE_APP_LOGO;
    },

        /**
     * Calculate contrast ratio between two hex colors
     * @param {string} hex1 - First hex color (e.g., "#FFFFFF").
     * @param {string} hex2 - Second hex color (e.g., "#000000").
     * @returns {number} - Contrast ratio (e.g., 21 for black and white).
     */
     getContrastRatio(hex1, hex2) {
      // Helper function to convert hex to RGB
      const hexToRgb = (hex) => {
        const value = hex.replace("#", "");
        return {
          r: parseInt(value.substring(0, 2), 16),
          g: parseInt(value.substring(2, 4), 16),
          b: parseInt(value.substring(4, 6), 16),
        };
      };

      // Helper function to calculate relative luminance
      const getLuminance = ({ r, g, b }) => {
        const toLinear = (channel) => {
          channel /= 255;
          return channel <= 0.03928
            ? channel / 12.92
            : Math.pow((channel + 0.055) / 1.055, 2.4);
        };
        return (
          0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b)
        );
      };

      const rgb1 = hexToRgb(hex1);
      const rgb2 = hexToRgb(hex2);

      const lum1 = getLuminance(rgb1);
      const lum2 = getLuminance(rgb2);

      // Calculate contrast ratio
      const brighter = Math.max(lum1, lum2);
      const darker = Math.min(lum1, lum2);

      return ((brighter + 0.05) / (darker + 0.05)).toFixed(2);
    },
  },
};
</script>

<style src="./style.css" scoped></style>
